/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  // ACCESSIBILITY FIX — .header__cart-icon is a decorative <div> wrapping the
  // cart icon + count inside the real interactive control (the surrounding
  // <a class="header__cart-toggle">, which already carries the correct
  // aria-expanded state). Something in the compiled theme bundle also mirrors
  // aria-expanded onto this inner div, which is invalid ARIA — a generic div
  // with no interactive role does not support aria-expanded. This strips it
  // from that exact element the instant it appears, without touching the
  // toggle behavior itself.
  function stripInvalidAriaExpanded(el) {
    if (el.classList.contains('header__cart-icon') && el.hasAttribute('aria-expanded')) {
      el.removeAttribute('aria-expanded');
    }
  }

  function init() {
    document.querySelectorAll('.header__cart-icon').forEach(function (el) {
      stripInvalidAriaExpanded(el);

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) { stripInvalidAriaExpanded(m.target); });
      }).observe(el, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
